import { useMemo, useState } from "react";
import { RegisterClienteIntermedioWithUsuarioForm } from "@/components/forms/clientes-intermedios/RegisterClienteIntermedioWithUsuarioForm";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@components/ui/dialog";
import DataTable from "@components/ui/dataTable";
import { useClientesIntermedios } from "@/hooks/clientes-intermedios/useClientesIntermedios";
import type { ClienteIntermedio } from "@interfaces/user.interface";
import { getClienteIntermedioColumns } from "@/lib/columns/clienteIntermedio.columns";
import { Skeleton } from "@/components/ui/Skeleton";

export default function ClientesIntermediarios() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const { data, isLoading, isFetching } = useClientesIntermedios(
    page,
    limit,
    search,
  );

  const createClienteIntermedioModal = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Registrar Cliente Intermedio
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Registrar Cliente Intermedio</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Llena el siguiente formulario para registrar un nuevo cliente
          intermedio.
        </DialogDescription>
        <div className="py-4">
          <RegisterClienteIntermedioWithUsuarioForm setOpen={setOpen} />
        </div>
      </DialogContent>
    </Dialog>
  );

  const clienteIntermedioColumns = useMemo(
    () =>
      getClienteIntermedioColumns(["clientesIntermedios", page, limit, search]),
    [page, limit, search],
  );

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-6 w-80" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  return (
    <section className="w-full p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6">
      <DataTable<ClienteIntermedio>
        columns={clienteIntermedioColumns}
        data={data?.data ?? []}
        total={data?.total ?? 0}
        page={page}
        limit={limit}
        onPageChange={setPage}
        isLoading={isFetching}
        search={search}
        onSearchChange={(value) => {
          setPage(1);
          setSearch(value);
        }}
        headerActions={createClienteIntermedioModal}
      />
    </section>
  );
}
